var map = {
	"./1.jpg": 43957,
	"./IMG_0839.JPG": 74833,
	"./IMG_0840.JPG": 36675,
	"./IMG_0841.JPG": 98357,
	"./IMG_0842.JPG": 46075,
	"./IMG_0843.JPG": 22256,
	"./IMG_0844.JPG": 94752
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63591;